function detectOS(): 'windows' | 'mac' | 'linux' | 'unknown' {
    const ua = window.navigator.userAgent;
    if (/Windows NT/.test(ua)) {
        return 'windows';
    }
    if (/Mac OS X/.test(ua)) {
        return 'mac';
    }
    if (/Linux/.test(ua)) {
        return 'linux';
    }
    return 'unknown';
}

export { detectOS };
